// ============================================
// 📱 APP: NVA (React App)
// 📄 FILE: src/lib/directions.ts
// 🔧 PURPOSE: "Come arrivare" all'appartamento: Google Maps con le
//             coordinate (le indicazioni) o, senza, con la ricerca
//             dell'indirizzo. Lo usano la tessera della vista B
//             (QuickActions) e, il giorno dell'arrivo, la card di "Adesso
//             per te" della vista S: le stesse regole in un posto solo.
// ============================================

import type { GuestBooking } from './guestApi';

type DirectionsBooking = Partial<Pick<GuestBooking, 'apartmentAddress' | 'apartmentLatitude' | 'apartmentLongitude'>>;

/** L'indirizzo o le coordinate dell'appartamento: senza, "Come arrivare" non porterebbe da nessuna parte. */
export function hasDirections(booking: DirectionsBooking | null | undefined): boolean {
  return !!(booking?.apartmentAddress || (booking?.apartmentLatitude && booking?.apartmentLongitude));
}

/** Google Maps verso l'appartamento: con le coordinate le indicazioni, se no la ricerca dell'indirizzo. */
export function openDirections(address?: string | null, lat?: number | null, lng?: number | null): void {
  if (lat && lng) {
    window.open(`https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`, '_blank');
  } else if (address) {
    window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`, '_blank');
  }
}
